import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Shield, CheckCircle, XCircle, Loader2 } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('No verification token found.');
      return;
    }
    const verify = async () => {
      try {
        await axios.post(`${API}/auth/verify-email?token=${token}`);
        setStatus('success');
        setMessage('Your email has been verified.');
      } catch (e) {
        setStatus('error');
        setMessage(e.response?.data?.detail || 'Verification failed. The link may have expired.');
      }
    };
    verify();
  }, [token]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="flex items-center justify-center gap-2 mb-8">
          <Shield className="w-6 h-6 text-[#FF3B30]" />
          <span className="font-heading text-white font-bold text-xl tracking-tight">RiskCoach<span className="text-[#FF3B30]">.ai</span></span>
        </div>
        <div className="bg-[#141414] border border-[#262626] rounded-sm p-8">
          {status === 'verifying' && (
            <>
              <Loader2 className="w-12 h-12 text-[#FF3B30] animate-spin mx-auto mb-4" />
              <h2 className="text-white font-bold text-xl mb-2">Verifying Your Email</h2>
              <p className="text-[#A3A3A3] text-sm">Please wait...</p>
            </>
          )}
          {status === 'success' && (
            <>
              <div className="w-12 h-12 bg-[#22C55E]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <CheckCircle className="w-6 h-6 text-[#22C55E]" />
              </div>
              <h2 data-testid="verify-success" className="text-white font-bold text-xl mb-2">Email Verified</h2>
              <p className="text-[#A3A3A3] text-sm mb-6">{message}</p>
              <Link
                to="/login"
                data-testid="verify-login-link"
                className="inline-block bg-[#FF3B30] hover:bg-[#D62828] text-white font-bold px-8 py-3 rounded-sm transition-colors"
              >
                Sign In
              </Link>
            </>
          )}
          {status === 'error' && (
            <>
              <div className="w-12 h-12 bg-[#FF3B30]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <XCircle className="w-6 h-6 text-[#FF3B30]" />
              </div>
              <h2 data-testid="verify-error" className="text-white font-bold text-xl mb-2">Verification Failed</h2>
              <p className="text-[#A3A3A3] text-sm mb-6">{message}</p>
              <Link
                to="/login"
                className="inline-block border border-[#262626] hover:border-white text-white px-6 py-3 rounded-sm transition-colors text-sm"
              >
                Back to Sign In
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
